import { Box, Skeleton } from '@mui/material'

/**
 * Skeleton for detail tab – matches screenshot:
 * Breadcrumb, object header (title + VIEW HISTORY + version + EDIT/LOCK/menu), 10 tabs, overview form sections.
 */
export const DetailPanelSkeleton = () => (
	<Box
		data-testid="detail-panel-skeleton"
		sx={{
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
			minHeight: 0,
			overflow: 'auto',
			bgcolor: '#fff',
		}}
	>
		{/* Breadcrumb */}
		<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 1.25, py: 0.75, borderBottom: '1px solid #ddd', bgcolor: '#fff' }}>
			<Skeleton variant="text" width={340} height={20} />
			<Skeleton variant="rounded" width={100} height={32} />
		</Box>
		{/* Object header: title left; right = VIEW HISTORY, then version + EDIT/LOCK/menu */}
		<Box
			sx={{
				display: 'flex',
				alignItems: 'flex-start',
				justifyContent: 'space-between',
				px: 1.875,
				py: 1.25,
				borderBottom: 1,
				borderColor: 'divider',
				bgcolor: '#fafafa',
				gap: 2,
			}}
		>
			<Skeleton variant="text" width={260} height={36} sx={{ flexShrink: 0 }} />
			<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.75 }}>
				<Skeleton variant="text" width={110} height={20} />
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					<Skeleton variant="text" width={220} height={18} />
					<Skeleton variant="rounded" width={56} height={28} />
					<Skeleton variant="rounded" width={48} height={28} />
					<Skeleton variant="rounded" width={36} height={28} />
				</Box>
			</Box>
		</Box>
		{/* 10 tabs */}
		<Box sx={{ display: 'flex', borderBottom: 1, borderColor: 'divider', bgcolor: '#fcfcfc', flexWrap: 'wrap' }}>
			{[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
				<Skeleton key={i} variant="rounded" width={i === 1 ? 92 : i === 3 ? 128 : 78} height={36} sx={{ borderRadius: 0 }} />
			))}
		</Box>
		{/* Overview form */}
		<Box sx={{ p: 2, flex: 1 }}>
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2 }}>
				{[1, 2, 3, 4, 5].map((r) => (
					<Box key={r} sx={{ display: 'flex', alignItems: 'center', gap: 2, maxWidth: 720 }}>
						<Skeleton variant="text" width={100} height={24} sx={{ flexShrink: 0 }} />
						<Skeleton variant="rounded" height={r === 3 ? 56 : 40} sx={{ flex: 1 }} />
					</Box>
				))}
			</Box>
			<Box sx={{ border: '1px solid #ddd', p: 1.25, mt: 1.875 }}>
				<Skeleton variant="text" width={120} height={20} sx={{ mb: 1 }} />
				<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
					{[1, 2, 3, 4].map((i) => (
						<Skeleton key={i} variant="rounded" width={96} height={28} />
					))}
				</Box>
			</Box>
			<Box sx={{ border: '1px solid #ddd', p: 1.25, mt: 2.5 }}>
				<Skeleton variant="text" width={160} height={20} sx={{ mb: 1.5 }} />
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
					{[1, 2, 3].map((r) => (
						<Box key={r} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
							<Skeleton variant="text" width={160} height={24} sx={{ flexShrink: 0 }} />
							<Skeleton variant="rounded" height={40} sx={{ flex: 1, maxWidth: 400 }} />
						</Box>
					))}
				</Box>
			</Box>
			<Box sx={{ border: '1px solid #ddd', p: 1.25, mt: 2.5 }}>
				<Skeleton variant="text" width={180} height={20} sx={{ mb: 1.5 }} />
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
					<Skeleton variant="text" width={60} height={24} sx={{ flexShrink: 0 }} />
					<Skeleton variant="rounded" height={40} sx={{ width: 200 }} />
				</Box>
			</Box>
			<Box sx={{ border: '1px solid #ddd', p: 1.25, mt: 2.5 }}>
				<Skeleton variant="text" width={160} height={20} sx={{ mb: 1.5 }} />
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
					{[1, 2].map((r) => (
						<Box key={r} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
							<Skeleton variant="text" width={140} height={24} sx={{ flexShrink: 0 }} />
							<Skeleton variant="rounded" height={40} sx={{ width: 200 }} />
						</Box>
					))}
				</Box>
			</Box>
		</Box>
	</Box>
)
